import { IDeepLinkInfoResponse } from '@gem/models/deeplinksModel';

import {
  ISticker,
  IStickerPackExtend,
  IStickerPacksList,
  StickerType,
} from 'APP/model/stickers/stickersModel.types';
import { StickerType as ProtoStickerType } from 'APP/wsApi/wsAppApi/types/common/common_model_pb';
import { Sticker, StickerPackEnriched } from 'APP/wsApi/wsAppApi/types/sticker/sticker_model_pb';

export function mapStickerType(type: ProtoStickerType): StickerType {
  switch (type) {
    case ProtoStickerType.ST_ANIMATED:
      return StickerType.Animated;
    default:
      return StickerType.Static;
  }
}

export function mapSticker(data: Sticker, stickerPackId: string): ISticker {
  return {
    ...data,
    id: String(data.id),
    stickerPackId,
    graphicSize: data.graphicSize!,
    type: mapStickerType(data.type),
  };
}

export function mapStickerPack(data: StickerPackEnriched): IStickerPackExtend {
  const stickerPack = data.stickerPack!;
  return {
    stickerPack: {
      ...stickerPack,
      id: String(stickerPack.id),
      isPrivate: false,
      isSharable: true,
      deepLink: {} as IDeepLinkInfoResponse,
    },
    stickers: data.stickers.map((item) => mapSticker(item, String(stickerPack.id))),
  };
}
export function mapPublicStickerPacksResponse(data: StickerPackEnriched[]): IStickerPacksList {
  return {
    cursor: null,
    items: data.map((item) => mapStickerPack(item)),
  };
}
